// Session-deletion API fns — carved verbatim from `src/api/scribeAPI.ts` (v1)
// and `src/api/scribeAPIV2.ts` (v2) with the D6 family. The consuming delete
// MUTATIONS stay app-side for now (they orchestrate offline-recording Tauri
// IPC, ehr invalidations and the not-yet-moved D1 list surface — see the D6
// scope note in tasks.md); they keep calling these fns through the api-hub
// shims. Transport from the `@heidi/api` registry; paths byte-identical.

import { getScribeHttpClients } from '@heidi/api/client';
import { type components, type operations } from '@heidi/schema/ml-scribe';

// Structural aliases of the app's `@/types` names (schema-derived there too).
type DeleteSessionsPayload =
  operations['batch_delete_sessions_api_v1_ml_scribe_sessions_batch_delete']['parameters']['query'];
type DeleteSessionsResponse = components['schemas']['DeleteEmptySessionsResponse'];

/** `DELETE /sessions/batch` (v1). */
export const deleteSessionByIds = (sessionIds: string[]) => {
  return getScribeHttpClients().scribeHttp.delete<DeleteSessionsPayload>(
    '/sessions/batch',
    {
      data: {
        session_id_list: sessionIds,
      },
    }
  );
};

/** `DELETE /sessions/` (v2) — delete every session. */
export const deleteAllSessions = () => {
  return getScribeHttpClients().scribeHttpV2.delete(`/sessions/`);
};

// tidy up sessions
export const deleteEmptySessions = () => {
  return getScribeHttpClients().scribeHttpV2.delete<DeleteSessionsResponse>(
    `/sessions:delete-empty`
  );
};
